import { render, staticRenderFns } from "./CustomerRelated.vue?vue&type=template&id=4eb9ab44&"
import script from "./CustomerRelated.vue?vue&type=script&lang=ts&"
export * from "./CustomerRelated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports